<template>
  <el-table-column :label="label" :prop="prop" class-name="callsign" :sortable="sortable">
    <template slot-scope="scope" v-if='scope.row.callsign'>
      {{scope.row.callsign}}
    </template>
    <template v-else-if='!scope.row.callsign'>
      -
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '便名'
    },
    prop: {
      type: String,
      default: 'callsign'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.callsign {
      width: 8em;
    }
  }
}
</style>
